import * as React from 'react';
import { MembershipItemIndexView, MembershipPlanIndexView } from '../../../types/membershipPlans';
import './planSummary.module.scss';
import { SummaryBody, SummaryHeader, SummaryPriceRow, SummarySplitter, SummarySubPriceRow } from './base';

type Props = {
    plan: MembershipPlanIndexView;
    item: MembershipItemIndexView;
};

export const PlanSummary = ({ item }: Props) => (
    <div styleName="plan-summary">
        <SummaryHeader subLabel={item.name}>プラン</SummaryHeader>
        <SummaryBody>
            <SummarySubPriceRow label="金額" price={item.price} unit="円（税別）" />
            {item.discount_campaigns.map((d) => {
                return (
                    <SummarySubPriceRow
                        key={d.name}
                        label={`${d.name} 適用（初回支払のみ）`}
                        price={-d.discount}
                        unit="円"
                    />
                );
            })}
            <SummarySubPriceRow label="消費税" price={item.tax} unit="円" />
            <SummarySplitter />
            <SummaryPriceRow label="合計" price={item.total_price} unit="円(税込)" />
        </SummaryBody>
    </div>
);
